<template>
  <span class="svg-icon-commo-chat">
    <svg :width="width"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.41421 18L3.70711 21.7071C3.07714 22.3371 2 21.8909 2 21V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V15C22 16.6569 20.6569 18 19 18H7.41421ZM4 18.5858L6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16H19C19.5523 16 20 15.5523 20 15V5C20 4.44772 19.5523 4 19 4H5C4.44772 4 4 4.44772 4 5V18.5858Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return '#FF2E38' } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>